import { useMutation } from '@apollo/client/react';
import { logError } from 'fergy-core-react-logging';
import { type SendMetaTrackingPixelMutation, type SendMetaTrackingPixelMutationVariables } from '../../__generated__/graphql-client-types';
import { SEND_META_TRACKING_PIXEL } from '../../queries/tracking-pixel/tracking-pixel.queries';

export const useSendMetaTrackingPixel = () => {
	const [sendMetaTrackingPixel] = useMutation<SendMetaTrackingPixelMutation, SendMetaTrackingPixelMutationVariables>(
		SEND_META_TRACKING_PIXEL
	);

	return (eventName: string, value: number, contentType: string, contentIds: string[], manufacturer: string, contentCategory: string) => {
		return sendMetaTrackingPixel({
			variables: {
				pixelEventData: {
					eventName,
					customData: {
						currency: 'USD',
						value,
						contentType,
						contentIds,
						manufacturer,
						contentCategory
					}
				}
			}
		}).catch(logError);
	};
};
